import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

const ExternalLink = ({ href, children, className, ...props }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (e) => {
    setIsLoading(true);
    // Reset after 2 seconds (external navigation will happen)
    setTimeout(() => setIsLoading(false), 2000);
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className={`relative ${className}`}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center bg-slate-900/80 rounded-lg">
          <Loader2 className="h-4 w-4 animate-spin text-cyan-400" />
        </span>
      )}
    </a>
  );
};

export default ExternalLink;